import { Messages } from 'react-big-calendar'

export const mountDateCalendar = (array: string[], start: boolean): Date => {
  return new Date(
    Number(array[0]),
    Number(array[1]) - 1,
    Number(array[2]),
    start ? 6 : 12,
    start ? 30 : 0,
    0
  )
}

export const Language: Messages = {
  today: 'Hoje',
  previous: 'Voltar',
  next: 'Próximo',
  month: 'Calendário',
  week: 'Semana',
  day: 'Dia',
  date: 'Data',
  time: 'Horário',
  event: 'Evento',
  noEventsInRange: 'Nenhum recebível agendado para liberação.',
  agenda: 'Lista'
}

/**
 * Valor curto pra caber na celula do dia no mobile (~51px de largura):
 * "1,2k", "573". O valor exato continua no modal do dia (clique na celula).
 */
export const formatMoneyCompact = (amount: string | number): string => {
  const parsed = Number(amount) || 0
  const sign = parsed < 0 ? '-' : ''
  const value = Math.abs(parsed)

  if (value >= 1000000)
    return `${sign}${(value / 1000000).toFixed(1).replace('.', ',')}M`
  if (value >= 1000)
    return `${sign}${(value / 1000).toFixed(1).replace('.', ',')}k`

  return `${sign}${Math.round(value)}`
}
